import RouteUrl from "~/config/route-url"
export default () => RouteUrl
